import type { ReactNode } from 'react';

export interface RailCardProps {
  readonly eyebrow?: string | undefined;
  readonly title?: string | undefined;
  readonly children: ReactNode;
  readonly className?: string | undefined;
}

/** A side-rail card used in Month / Week / Day / Agenda views. Contains a
 *  small uppercase eyebrow, an optional headline, and arbitrary children. */
export function RailCard(props: RailCardProps): ReactNode {
  const { eyebrow, title, children, className } = props;
  return (
    <section className={['vq-cal__rail-card', className].filter(Boolean).join(' ')}>
      {eyebrow !== undefined && <div className="vq-cal__rail-eyebrow">{eyebrow}</div>}
      {title !== undefined && <h3 className="vq-cal__rail-title">{title}</h3>}
      {children}
    </section>
  );
}
